/**
 * Single source of truth for the search facet ranges, shared by BOTH
 * experiment arms — the two arms of the running as-search-ssr experiment must
 * define identical facets, so neither arm may keep its own copy.
 *
 * Two layers consume this and must stay in lock-step:
 *  - the engines (CSR facetControllers, SSR headless/engineDefinition) read
 *    `start`/`end` (and `days`) to BUILD the Coveo facets, and
 *  - the facet components read `label`/`bundleKey` to LABEL/localize +
 *    breadcrumb them.
 *
 * Pure data with no imports, so it can be shared across the engine and display
 * layers without dragging Coveo or CMS dependencies into either.
 *
 * `bundleKey` matches the Coveo facet value keys in the Contentful "Search UI
 * Values" set (e.g. search-ui-values.ec_price_filter.*), resolved via
 * microcopySetToResourceBundles. The dollar-amount ranges are locale-agnostic,
 * so only Free/Under/Over strictly need translating; `label` is the English
 * fallback when no entry exists.
 */

export const PRICE_RANGES = [
  { start: 0, end: 0, label: 'Free', bundleKey: 'free' },
  { start: 0.01, end: 20, label: 'Under $20', bundleKey: 'under-20' },
  { start: 20, end: 50, label: '$20 – $50', bundleKey: '20-50' },
  { start: 50, end: 100, label: '$50 – $100', bundleKey: '50-100' },
  { start: 100, end: 200, label: '$100 – $200', bundleKey: '100-200' },
  { start: 200, end: 999999, label: 'Over $200', bundleKey: 'over-200' },
];

export const RATING_RANGES = [
  { start: 5, end: 5, label: '5 Stars', bundleKey: '5-stars' },
  { start: 4, end: 5, label: '4+ Stars', bundleKey: '4-stars' },
  { start: 3, end: 5, label: '3+ Stars', bundleKey: '3-stars' },
  { start: 2, end: 5, label: '2+ Stars', bundleKey: '2-stars' },
  { start: 1, end: 5, label: '1+ Stars', bundleKey: '1-star' },
];

// Release Date facet ranges (relative to now).
export const DATE_RANGE_KEYS = [
  { days: 1, label: 'Last 24 hours', bundleKey: '1-day-ago' },
  { days: 7, label: 'Last week', bundleKey: '1-week-ago' },
  { days: 31, label: 'Last month', bundleKey: '1-month-ago' },
  { days: 180, label: 'Last 6 months', bundleKey: '6-months-ago' },
  { days: 365, label: 'Last year', bundleKey: '1-year-ago' },
];
